<template>
  <div ref="presentationViewer">
    <iframe id="presentationFrame" :src="presentationUrl" :style="{ height: '75vh', width: '100%', 'border-radius': '15px'}" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>

    <div v-show="!onlyContent" class="fab_direction-up" :class="$siteTypeId() == 1 ? 'block-important' : ''">
      <div class="float-btn-group">
        <button class="btn-float btn-triger school-primary_gradient glow-effect_primary" @click="openActions">
          <i class="icon feather icon-more-horizontal text-white" />
        </button>
        <div class="btn-list">
          <a v-if=" (!$isProductionEnv()) || ($isProductionEnv() && [21,24].includes($getSiteId()))" class="btn-float dc_dark-purple description glow-effect_dark" @click="showQaPopup">
            <span class="descriptiontext">{{ "Ask a Question" }}</span>
            <i class="icon feather icon-help-circle text-white"></i>
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" @click="backToTopic">
            <span class="descriptiontext">{{ topicName }}</span>
            <i class="icon feather icon-arrow-up text-white"></i>
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="nextTask" @click="next">
            <span class="descriptiontext">NEXT</span>
            <i class="icon feather icon-arrow-right text-white" />
          </a>
          <a class="btn-float dc_dark-purple description glow-effect_dark" v-show="prevTask" @click="previous">
            <span class="descriptiontext">PREVIOUS</span>
            <i class="icon feather icon-arrow-left text-white" />
          </a>
        </div>
      </div>
    </div>

    <vs-popup 
      title="Ask a question"
      :active.sync="isQaPopupActive">
        <q-a
        :isActive = isQaPopupActive
      />
    </vs-popup>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid';
import QA from '../components/q-a/QA.vue'

export default {
  components:{
    QA
  },
  data() {
    return {
      queue: [],
      uuid: "",
      logData: {},
      fabElement: null,
      presentation: {},
      presentationUrl: null,
      onlyContent : false,
      standaloneContentDto: {},
      selectedData: {},
      topicName: '',
      index: null,
      currentTask: null,
      nextTask: null,
      prevTask: null,
      navigateByChoice: false,
      isTeacher: false,
      isStudentLocal: false,
      isQaPopupActive:false,
      isUserPremium: false,
      onSuccessForUserCheck: false,
      startCourseTaskLog: false,
    };
  },
  methods: {
    closeQaPopup(){
      var self = this;
      self.isQaPopupActive = false;
    },
    showQaPopup(){
      var self = this;
      self.isQaPopupActive = true;
    },
    backToTopic() {
      var self = this;
      self.navigateByChoice = false;
      if (self.$route.query.ref == "resources") {
        if (self.isTeacher) {
          self.$router.push({ name: 'TeacherResources'});
        } else if (self.isStudentLocal) {
          self.$router.push({ name: 'StudentAdditionalResources'})
        }
      } else {
        if(self.selectedData.selectedTopic && self.isTeacher)
          self.$router.push({ name: 'TeacherBrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
        else if(self.selectedData.selectedTopic && self.isStudentLocal)
          self.$router.push({ name: 'BrowseContent', params: { selectedData: self.selectedData, navFromVideo: true } });
        else
          self.$router.push({ name: 'StudentRoster'});
      }
    },
    next() {
      var self = this;
      self.index += 1;

      var data = {
        selectedData: self.selectedData,
        standaloneContentDto: self.standaloneContentDto,
        index: self.index
      }

      if(self.index >= self.standaloneContentDto.tasks.length){
        self.backToTopic()
        return;
      }

      localStorage.setItem("lastKnownTopic", JSON.stringify(data));

      if(self.nextTask) {     
        self.closeActions();
        self.presentationUrl = null;

        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = self.currentTask.id;
        self.logData.toTaskId = self.nextTask.id;
        self.enqueue("PresentationTask/EndLogEntry", self.logData);

        self.currentTask = self.nextTask;
        
        self.uuid = self.$uuid.v4();
        self.logData.taskId = self.currentTask.id;
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = null;

        self.nextTask = self.index + 1 <= self.standaloneContentDto.tasks.length ? self.standaloneContentDto.tasks[self.index + 1] : null;
        self.prevTask = self.standaloneContentDto.tasks[self.index - 1];

        self.logData.fromTaskId = (self.prevTask ? self.prevTask.id : null);

        if(self.currentTask.presentation && self.currentTask.presentation.id) {
          if(!self.isUserPremium  && !self.currentTask.isPremium)
          {
            self.navigateByChoice = false;
            self.presentation = self.currentTask.presentation;
            self.presentationUrl = self.presentation.url;

            self.enqueue("PresentationTask/StartLogEntry", self.logData);
          }
          else if(self.$store.state.aclSubscription.status.includes("PremiumContent"))
          {
            self.navigateByChoice = false;
            self.presentation = self.currentTask.presentation;
            self.presentationUrl = self.presentation.url;

            self.enqueue("PresentationTask/StartLogEntry", self.logData);
          }
          else
          {
            self.showPremiumContentPopup();
          }
        }
        else if(self.currentTask.video && self.currentTask.video.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if(self.currentTask.document && self.currentTask.document.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "DocumentViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if (self.currentTask.podcast && self.currentTask.podcast.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PodcastViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "LiveStreamViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if (self.currentTask.videoChat && self.currentTask.videoChat.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoChatPage",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if (self.currentTask.upload && self.currentTask.upload.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "UploadViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.prevTask ? self.prevTask.id : null)
            }
          });
        }
        else if(self.currentTask.externalLink && self.currentTask.externalLink.id){
          self.navigateByChoice = true;
          self.next();
        }
      }
    },
    previous() {
      var self = this;
      self.index = --self.index;

      if(self.index < 0){
        self.backToTopic();
        return;
      }
      
      var data = {
        selectedData: self.selectedData,
        standaloneContentDto: self.standaloneContentDto,
        index: self.index
      }

      localStorage.setItem("lastKnownTopic", JSON.stringify(data));
      
      if(self.prevTask) {
        self.closeActions();
        self.presentationUrl = null;

        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = self.currentTask.id;
        self.logData.toTaskId = self.prevTask.id;
        self.enqueue("PresentationTask/EndLogEntry", self.logData);

        self.currentTask = self.prevTask;

        self.uuid = self.$uuid.v4();
        self.logData.taskId = self.currentTask.id;
        self.logData.logIdentifier = self.uuid;
        self.logData.toTaskId = null;

        self.nextTask = self.standaloneContentDto.tasks[self.index + 1];
        self.prevTask = self.index > 0 ? self.standaloneContentDto.tasks[self.index - 1] : null;

        self.logData.fromTaskId = (self.nextTask ? self.nextTask.id : null);

        if(self.currentTask.presentation && self.currentTask.presentation.id) {
          if(!self.isUserPremium  && !self.currentTask.isPremium)
          {
            self.navigateByChoice = false;
            self.presentation = self.currentTask.presentation;
            self.presentationUrl = self.presentation.url;
            self.enqueue("PresentationTask/StartLogEntry", self.logData);
          }
          else if(self.$store.state.aclSubscription.status.includes("PremiumContent"))
          {
            self.navigateByChoice = false;
            self.presentation = self.currentTask.presentation;
            self.presentationUrl = self.presentation.url;
            self.enqueue("PresentationTask/StartLogEntry", self.logData);
          }
          else
          {
            self.showPremiumContentPopup();
          }
        }
        else if(self.currentTask.video && self.currentTask.video.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if(self.currentTask.document && self.currentTask.document.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "DocumentViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if (self.currentTask.podcast && self.currentTask.podcast.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "PodcastViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            },
            query:{ref: self.$route.query.ref && self.$route.query.ref == "resources" ? "resources" : "none"}
          });
        }
        else if (self.currentTask.liveStream && self.currentTask.liveStream.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "LiveStreamViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
        else if (self.currentTask.videoChat && self.currentTask.videoChat.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "VideoChatPage",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
        else if (self.currentTask.upload && self.currentTask.upload.id) {
          self.navigateByChoice = true;
          self.$router.push({
            name: "UploadViewer",
            params: {
              index: self.index,
              standaloneContent: self.standaloneContentDto,
              selectedData: self.selectedData,
              fromTaskId: (self.nextTask ? self.nextTask.id : null)
            }
          });
        }
        else if(self.currentTask.externalLink && self.currentTask.externalLink.id){
          self.navigateByChoice = true;
          self.previous();
        }
          
      }
    },
    openActions(e) {
      this.fabElement = e.target.closest(".float-btn-group");
      if (this.fabElement) {
        this.fabElement.classList.toggle('open')
      }
    },
    closeActions() {
      if (this.fabElement) {
        this.fabElement.classList.remove('open')
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    enqueue(messageType, logPayload) {
      this.queue.push({
        type: messageType,
        payload: {
          logIdentifier: logPayload.logIdentifier.toString(),
          toTaskId: logPayload.toTaskId,
          fromTaskId: logPayload.fromTaskId,
          taskId: logPayload.taskId,
        }
      })
    },
    dequeue() {
      return this.queue.shift();
    },
    startProcessor() {
      var self = this;
      var onSuccess = function (response) {
        var next = self.dequeue();
        if (next)
          self.process(next, onSuccess);
      };
      setInterval(function () {
        if (self.queue.length > 0) {
          self.process(self.dequeue(), onSuccess)
        }
      }, 3000)
    },
    process(queueItem, successFunc) {
      var self = this;
      if (queueItem) {
        self.$ajaxPost(self, queueItem.type, queueItem.payload, function(response){
          successFunc();
        });
      }
    },
    getIsUserPremium(onComplete){
      var self = this;
      var onSuccess = function(response){
        if(response.data){
          self.activeSubscription = response.data != null ? response.data : 0;
          self.isUserPremium = response.data.isUserPremium;
        }
        onComplete();
      }
      self.$ajaxGet(self, "public/getactivesubscription" , onSuccess);
    },
    showPremiumContentPopup() {
      var self = this;
      self.$swal({
        title: 'Cannot Continue',
        icon: 'warning',
        backdrop: true,
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Subscribe',
        html: `This is a premium task. <br> To access this content you have to be a <strong>premium subscriber</strong>.`,
        customClass: {
          confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled mr-3',
          cancelButton: 'vs-component vs-button vs-button-warning vs-button-border ml-3',
        },
        showClass: {
          popup: 'animate__animated animate__tada',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) { // <-- if confirmed
          window.open("/subscriptions");
        }
        else{
          self.backToTopic();
        }
      });
    },
  },
  beforeDestroy() {
    var self = this;
    if(self.startCourseTaskLog){
      if(!self.navigateByChoice) {
        self.logData.logIdentifier = self.uuid;
        self.logData.fromTaskId = self.currentTask.id;
        self.logData.taskId = self.currentTask.id;
        self.logData.toTaskId = null;
        self.enqueue("PresentationTask/EndLogEntry", self.logData);
        self.presentationUrl = null;
      }
    }
  },
  mounted() {
    var onComplete = response => {
      var self = this;
      self.uuid = self.$uuid.v4();
      self.$store.dispatch("updateTheme", "dark");
      self.startProcessor();

      self.isTeacher = self.$acl.check("Teacher");

      self.isStudentLocal = self.$acl.check("Student");

      var selectData = localStorage.getItem('lastKnownTopic');
        if(selectData){
          var dataObject = JSON.parse(selectData);
          self.index = dataObject.index;
          if(self.index < 0)
            self.index = 0;
          self.selectedData = dataObject.selectedData;
          if(self.selectedData.selectedTopic)
            self.topicName = self.selectedData.selectedTopic.name;
          else
            self.topicName = "Back to My Roster";
          self.standaloneContentDto = dataObject.standaloneContentDto;
          if (self.standaloneContentDto.tasks.length > self.index + 1)
            self.nextTask = self.standaloneContentDto.tasks.filter(function(item) { return item.index == (self.index + 1) })[0];
          if (self.index > 0)
            self.prevTask = self.standaloneContentDto.tasks.filter(function(item) { return item.index == (self.index - 1) })[0];
          self.currentTask =  self.standaloneContentDto.tasks.filter(function(item) { return item.index == self.index })[0];
          
          localStorage.setItem("tid", self.currentTask.id);

        }

      if (Object.keys(self.$route.query).length != 0 && Object.keys(this.$route.params).length == 0) {
        if(self.$route.query.id){
          self.showLoadingOnElement("presentationViewer", 1, "material");
          if(!localStorage.getItem("userInfo")) {
            document.cookie = "autoRedirect="+ JSON.stringify({url: "PresentationViewer", id: self.$route.query.id});
            window.location.replace("/login");
          }

          var success = (res) => {
            self.onlyContent = true;
            self.presentation = {};  
            self.presentation.url = res.data.url; 

            self.presentationUrl = self.presentation.url;
            self.logData.taskId = self.$route.query.id;
            localStorage.setItem("tid", self.$route.query.id);
            self.logData.logIdentifier = self.uuid;
            self.logData.toTaskId = null;
            self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.presentationViewer.$el);
          };

          try{
            self.$ajaxGet(self, "PresentationTask/GetPresentationByTaskId/" + self.$route.query.id, success, onFinally);
          } catch{} 
        }
      }
      else {
        if(Object.keys(this.$route.params).length != 0){
          self.index = self.$route.params.index;

          self.currentTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0];

          self.presentation = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == self.index })[0].presentation;

          if (self.$route.params.standaloneContent.tasks.length > self.index + 1)
            self.nextTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index + 1) })[0];

          if (self.index > 0)
            self.prevTask = self.$route.params.standaloneContent.tasks.filter(function(item) { return item.index == (self.index - 1) })[0];

          self.standaloneContentDto = self.$route.params.standaloneContent;
          if(self.$route.params.selectedData)
            self.selectedData = self.$route.params.selectedData;

          var data = {
            selectedData: self.selectedData,
            standaloneContentDto: self.standaloneContentDto,
            index: self.index
          }

          localStorage.setItem("lastKnownTopic", JSON.stringify(data));

          if(self.selectedData.selectedTopic)
            self.topicName = self.selectedData.selectedTopic.name;
          else
            self.topicName = "Back to My Roster";

          self.presentationUrl = self.presentation.url;
          if(!self.isUserPremium  && !self.currentTask.isPremium)
          {
            self.logData.taskId = self.currentTask.id;
            localStorage.setItem("tid", self.currentTask.id);
            self.logData.logIdentifier = self.uuid;
            self.logData.toTaskId = null;
            self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
            self.enqueue("PresentationTask/StartLogEntry", self.logData);
          }
          else if(self.$store.state.aclSubscription.status.includes("PremiumContent")){
            self.logData.taskId = self.currentTask.id;
            localStorage.setItem("tid", self.currentTask.id);
            self.logData.logIdentifier = self.uuid;
            self.logData.toTaskId = null;
            self.logData.fromTaskId = self.$route.params.fromTaskId ? self.$route.params.fromTaskId : null;
            self.enqueue("PresentationTask/StartLogEntry", self.logData);
          }
          else{
            self.showPremiumContentPopup();
          }
        }
        else {
          if (isStudentLocal) {
            self.$router.push({ name: 'StudentRoster' });
          }
          else {
            self.$router.push({ name: 'BrowseContent' });
          }
        }
      }
    }
    this.getIsUserPremium(onComplete);
  }
};
</script>

<style lang="scss">
  .contentCards {
    margin: auto;
  }

  .fab_direction-up__three-items {
    right: 70px;
    bottom: 4vh;
    z-index: 999;
    position: fixed;
  }

.block-important{
  display: block !important;
}
</style>
